var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6665 13C7.04722 13 8.1665 11.8807 8.1665 10.5C8.1665 9.11929 7.04722 8 5.6665 8C4.28579 8 3.1665 9.11929 3.1665 10.5C3.1665 11.8807 4.28579 13 5.6665 13Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4165 18.625C15.7972 18.625 16.9165 17.5057 16.9165 16.125C16.9165 14.7443 15.7972 13.625 14.4165 13.625C13.0358 13.625 11.9165 14.7443 11.9165 16.125C11.9165 17.5057 13.0358 18.625 14.4165 18.625Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4165 7.375C15.7972 7.375 16.9165 6.25571 16.9165 4.875C16.9165 3.49429 15.7972 2.375 14.4165 2.375C13.0358 2.375 11.9165 3.49429 11.9165 4.875C11.9165 6.25571 13.0358 7.375 14.4165 7.375Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3149 6.22656L7.76807 9.14844",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76807 11.8516L12.3149 14.7734",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.54095f55be24a4bd526fc5cac6282425.svg";
export { ForwardRef as ReactComponent };